import { PageLink } from '../../../_start/layout/core';

export const clientManagementSubmenu: Array<PageLink> = [
  {
    title: 'Partners',
    path: '/client-management/partners',
    isActive: true,
  },
];
